import React from 'react'
import { ThreeDots } from 'react-loader-spinner'
import clsx from 'clsx'
import { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent } from '@theme/components/ui/tooltip'

type ButtonProps = {
  disabled?: boolean
  children?: React.ReactNode
  isLoading?: boolean
  isCancelButton?: boolean
  className?: string
  component?: React.ElementType
  disabledTooltipMessage?: string | null
  [x: string]: any
}

const Button = ({
  disabled,
  children,
  isLoading = false,
  isCancelButton = false,
  className,
  component: Component = 'button',
  disabledTooltipMessage = null,
  ...rest
}: ButtonProps) => {
  const buttonElement = (
    <Component
      className={clsx(
        `button-wrapper relative text-center bg-primary rounded mt-8 py-2 px-6 text-white block cursor-pointer`,
        disabled && `bg-primary/70 cursor-not-allowed`,
        isCancelButton && 'cancel',
        className
      )}
      disabled={disabled}
      {...rest}
    >
      {isLoading && (
        <span className="absolute inset-0 flex items-center justify-center">
          <ThreeDots color={'#fff'} height={15} width={35} />
        </span>
      )}

      <span className={clsx('my-auto', isLoading && `opacity-0`)}>{children}</span>
    </Component>
  )

  if (disabled && disabledTooltipMessage) {
    return (
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger>{buttonElement}</TooltipTrigger>
          <TooltipContent
            onPointerDownOutside={(event) => {
              event.preventDefault()
            }}
            side="bottom"
          >
            {disabledTooltipMessage}
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return buttonElement
}

export default Button
